// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@conklin/MobiusOverrides/Tooltip";
import { xScreen } from "@conklin/XDL/Utilities";
import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

shareListModalStyles.recipientEmailTooltip = {
    extendedStyles: {
        triggerWrapper: {
            css: css`
                display: inline-block;
                margin-left: 5px;
                position: absolute;
            `,
        },
    },
    typographyProps: {
        weight: "normal",
    },
} as TooltipPresentationProps;

shareListModalStyles.shareListTooltip = {
    extendedStyles: {
        triggerWrapper: {
            css: css`
                margin-left: 5px;
            `,
        },
    },
    typographyProps: {
        lineHeight: "16px",
    },
} as TooltipPresentationProps;

shareListModalStyles.buttonsContainer = {
    gap: 10,
    css: css`
        & ${GridOffset} {
            justify-content: flex-end;
        }
    `,
};

shareListModalStyles.shareByOptionRadioGroup = {
    css: css`
        flex-direction: row;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: column;
                    `,
                ],
                "max",
            )}
    `,
};

shareListModalStyles.shareByEmailRadio = {
    css: css`
        & + & {
            margin-top: 0 !important;
            margin-left: 20px;
            ${xScreen("lte", "xs")} {
                margin-left: 0;
            }
        }
        input {
            margin-left: 0;
        }
    `,
};

shareListModalStyles.shareListOptionRadioGroup = shareListModalStyles.shareByOptionRadioGroup;

shareListModalStyles.sendCopyRadio = shareListModalStyles.shareByEmailRadio;

shareListModalStyles.container = { gap: 15 };

shareListModalStyles.shareListOptionText = shareListModalStyles.shareByOptionText = {
    css: css`
        display: block;
        margin-bottom: 8px;
    `,
};

shareListModalStyles.yourNameGridItem = shareListModalStyles.recipientEmailAddressGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        ${({ showEmailField }: any) => (!showEmailField ? "display: none" : "display: inline-flex")};
    `,
};
